import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=2fd44a19&scoped=true&"
import script from "./EventList.vue?vue&type=script&lang=js&"
export * from "./EventList.vue?vue&type=script&lang=js&"
import style0 from "./EventList.vue?vue&type=style&index=0&id=2fd44a19&prod&scoped=true&lang=scss&"
import style1 from "./EventList.vue?vue&type=style&index=1&id=2fd44a19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd44a19",
  null
  
)

export default component.exports